import { router } from './router'
import { getLogin } from '@/utils/auth'
import store from './store'

const whiteList = [
  '/login',
  '/signup',
  '/auth',
  '/404'
]
router.beforeEach(async (to, from, next) => {
  const isLogin = getLogin()
  if (whiteList.includes(to.path)) {
    return next()
  }
  if (isLogin) {
    // 登陆后没有用户信息
    let infos = store.getters.infos
    if (!infos.id) {
      await store.dispatch('user/getInfo').catch(err => {
        console.log('err:', err)
        next('/login')
      })
      infos = store.getters.infos
    }
    next()
  } else {
    // 登录
    next('/login')
  }
})
